import React, { useState } from "react";
import "./Innovation.css";
import img from "../../../../assets/images/Innovation/image 21.png";
import academic from "../../../../assets/images/Innovation/academic.png";
import soft from "../../../../assets/images/Innovation/Group.png";
import intern from "../../../../assets/images/Innovation/Internship.png";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
function Innovation({ executeScrollContact }) {
  const { t } = useTranslation();
  const [internshipview, setinternshipview] = useState("none");
  const [academicview, setacademicview] = useState("none");
  const [softview, setsoftview] = useState("none");

  const setInnovationModal = (a) => {
    if (a === "internship") {
      setinternshipview("block");
      setacademicview("none");
      setsoftview("none");
    } else if (a === "academic") {
      setacademicview("block");
      setinternshipview("none");
      setsoftview("none");
    } else if (a === "soft") {
      setsoftview("block");
      setacademicview("none");
      setinternshipview("none");
    }
  };

  const contactus = () => {
    setinternshipview("none");
    setacademicview("none");
    setsoftview("none");

    setTimeout(() => {
      executeScrollContact();
    }, 500);
  };
  return (
    <div className="innovation">
      <div className="innovation-container-1">
        <div className="innovation-text-opportunity">
          <h5>{t("We offer opportunities for:")}</h5>
        </div>
        <div className="innovation-box">
          <Link
            data-bs-toggle="modal"
            data-bs-target="#exampleModalInnovation"
            onClick={() => {
              setInnovationModal("academic");
            }}
          >
            <div className="academic" id="academic">
              <img src={academic} alt="academic"/>
              <p className="textbox-head">{t("Academic projects")} </p>
            </div>
          </Link>
          <Link
            data-bs-toggle="modal"
            data-bs-target="#exampleModalInnovation"
            onClick={() => {
              setInnovationModal("soft");
            }}
          >
            <div className="soft" id="soft">
              <img src={soft} alt="soft"/>
              <p className="textbox-head">{t("Lighten Skills")} </p>
            </div>
          </Link>
          <Link
            data-bs-toggle="modal"
            data-bs-target="#exampleModalInnovation"
            onClick={() => {
              setInnovationModal("internship");
            }}
          >
            <div className="internship" id="internship">
              <img src={intern} alt="intern"/>
              <p className="textbox-head">{t("Internships")} </p>
              <p className="textbox-para">
                {t("Discover internship")} <br />
                {t("opportunities and")} <br />
                {t("academic projects that")}
                <br />
                {t("bridge the gap between ")}
                <br />
                {t("theory and practice")}
              </p>
            </div>
          </Link>
        </div>

        <div
          className="modal fade"
          id="exampleModalInnovation"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 style={{ display: academicview }}>Academic Projects</h4>
                <h4 style={{ display: internshipview }}> Internship with Placement Opportunities </h4>
                <h4 style={{ display: softview }}>Academic Internships</h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <p  className="innovation-popup"
                  style={{ display: internshipview }}
                >
                  This course offers expert training in the respective fields
                  along with work experience placement in a real environment.
                  The focus is on imparting training from the basic segments of
                  software development to project scheduling, designing,
                  testing, and hosting. It provides you with the unique
                  opportunity to gain valuable work experience in the domestic
                  and international job markets. Work experience certificates
                  are issued immediately to those who complete the requirements
                  of the programs.
                </p>
                <p  className="innovation-popup"
                  style={{ display: academicview }}
                >
                  Technologies in which students projects can be offered:
                </p>
                <ul style={{ display: academicview }}>
                  <li>PYTHON Django</li>
                  <li> JAVA</li>
                  <li>Web Development</li>
                  <li>ANDROID</li>
                  <li>REACT JS</li>
                  <li>REACT NATIVE</li>
                  <li>MYSQL / Mongo DB / Oracle Data Base</li>
                  <li>IoT</li>
                  <li>AI</li>
                  <li> Machine Learning</li>
                  <li>Embedded Technology</li>
                </ul>
                <p className="innovation-popup" 
                style={{ display: softview }}>
                  Our team comprises seasoned professionals with extensive
                  experience in renowned MNCs, ensuring our students receive
                  top-notch instruction and practical insights. We are committed
                  to guiding every student who walks through our doors toward a
                  path of exponential career growth. With a meticulously crafted
                  curriculum and industry experts serving as mentors, our
                  courses offer a comprehensive package for aspiring individuals
                  seeking to establish themselves in the dynamic IT and Mobile
                  Development industry.
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                  onClick={contactus}
                >
                  Contact us
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="innovation-container-2">
        <div className="innovation-text-main">
          <div className="innovation-text-head">
            <h2> {t("Where Learning and Innovation begin!!")}</h2>
          </div>
          <div className="innovation-text-para">
            <p>
              {t("There are new technologies and tools released")}
              {t("into the world every day and staying abreast of")}
              {t("them helps both students and IT professionals to")}
              {t("be innovative and competitive in same")}
              {t("measure. We offer full-fledged web development")}
              {t("courses for Software Programmer Training")} (
              {t("Duration: 6 months")}) {t("and short-term courses")}
              {t("(2 to 3 months) as well.")}
            </p>
          </div>
          <div className="innovation-text-list">
            <ul style={{ zIndex: "5" }}>
              <li> {t("Certified Software Apprenticeships")}</li>
              <li> {t("Short-term Training Programs")}</li>
              <li> {t("Long-term Specialized Coaching")}</li>
            </ul>
            <div className="innovation-text-list image">
              <img src={img} id="innovation-img" alt="innovation"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Innovation;
